import { z } from "zod";
import { SectionSpacingSchema } from "../../../../../zod/shared-schemas.mjs";
const CardSectionCategoriesItemSchema = z.object({
  link: z.string(),
  image: z.string().optional(),
  alt: z.string().optional(),
  title: z.string().optional(),
  subtitle: z.union([z.string(), z.number()]).optional(),
  variant: z.enum(["gray", "red", "yellow", "blue"]).optional(),
  size: z.enum(["small", "big"]).optional()
});
const CardSectionCategoriesSchema = z.object({
  id: z.string().optional(),
  categories: CardSectionCategoriesItemSchema.array()
}).merge(SectionSpacingSchema);
export default CardSectionCategoriesSchema;
